<mat-card class="mb-3">
    <mat-card-content>
        <div class="row">
            <div class="col-12 col-md-5">
                <div class="h6">{{title}}</div>
                @if (!!description) {
                <small class="text-muted d-block mb-3" style="line-height: 1rem;">{{description}}</small>
                }
                <div>
                    <ng-content select="[addOn]"></ng-content>
                </div>
            </div>

            <div class="col">
                @if (isLoading) {
                <div class="d-flex justify-content-center w-100">
                    <mat-spinner color="primary" diameter="45"></mat-spinner>
                </div>
                }
                @else {
                <ng-content></ng-content>
                }
            </div>
        </div>
    </mat-card-content>
</mat-card>